import { io, Socket } from 'socket.io-client';

const SERVER_URL = (import.meta.env.VITE_API_URL || '').replace(/\/api\/?$/, '');

export const socket: Socket = io(SERVER_URL, {
  transports: ['websocket', 'polling'], // allow polling as fallback
  upgrade: true,
  reconnectionDelay: 1000,
  reconnectionAttempts: 5,
  autoConnect: false, // Connect manually when needed
});
